import React, { RefObject, useContext } from 'react';
import { ThemeProvider } from 'emotion-theming';
import useSWR from 'swr';
import qs from 'qs';
import { ListResponse, Retailer } from '@ordermentum/ui-types';
import { Theme, ThemeContext } from '../../utilities/theme';
import { ColorCodes, colorsForTheme } from '../../foundations/color';
import { fetcher } from '../../swr/fetchers';
import {
  ContentWrapper,
  OptionContainer,
  OptionHeader,
} from './Switcher.styles';
import SwitcherOption from './SwitcherOption';

type StateProps = {
  params?: { retailerId?: string; supplierId?: string };
  retailers?: string[];
  external?: boolean;
  showHeader?: boolean;
  context?: string;
};

const getTheme = (theme: Theme): themeStyles => {
  const colors = colorsForTheme(theme);
  const colorThemes = {
    textColor: colors.SPACE,
    iconColor: colors.STORM,
    iconBorderColor: colors.ASH,
    activeColor: colors.PEACH,
    optionRowHeaderColor: colors.STEEL,
  };
  return colorThemes;
};

type themeStyles = {
  textColor: ColorCodes;
  iconColor: ColorCodes;
  iconBorderColor: ColorCodes;
  activeColor: ColorCodes;
  optionRowHeaderColor: ColorCodes;
};

type retailers = {
  id: string;
  name: string;
  suppliers: string[];
};

export const RetailerSwitcher = React.forwardRef(
  (props: StateProps, ref: RefObject<HTMLDivElement>) => {
    const themeStyle = getTheme(useContext(ThemeContext));
    const { params, retailers = [], external, showHeader, context } = props;
    const retailerId = params?.retailerId;
    let optionList: retailers[] = [];

    const { data } = useSWR<ListResponse<Retailer>>(
      `/v2/retailers?${qs.stringify({ id: retailers })}`,
      fetcher()
    );

    if (!data?.data) {
      return <></>;
    }

    optionList = data.data
      .filter(retailer => retailers.indexOf(retailer.id) > -1)
      .map(retailer => ({
        id: retailer.id,
        name: retailer.tradingName,
        suppliers: retailer.supplierIds,
      }));

    const getActive = optionId => {
      if (context === 'supplier') return false;
      return retailerId === optionId;
    };

    return (
      <ThemeProvider theme={themeStyle}>
        <ContentWrapper data-testid="retailer-switcher" ref={ref}>
          <OptionContainer>
            {showHeader && <OptionHeader>Venues</OptionHeader>}
            {optionList.map(option => (
              <SwitcherOption
                key={option.id}
                option={option}
                url={`/dashboard/${option.id}/home`}
                external={external}
                active={getActive(option.id)}
              />
            ))}
          </OptionContainer>
        </ContentWrapper>
      </ThemeProvider>
    );
  }
);
export default RetailerSwitcher;
